import React from 'react';
import './VirtualTour.css';

const VirtualTour = ({ project }) => {
  return (
    <div className="virtual-tour-container">
      <div className="section-header">
        <h3>Virtual Tour</h3>
        <p>Configure virtual tour settings</p>
      </div>
      
      <div className="tour-settings">
        <div className="setting-item">
          <label>Tour Mode</label>
          <select>
            <option>Walkthrough</option>
            <option>Flythrough</option>
            <option>Orbit</option>
          </select>
        </div>
        <div className="setting-item">
          <label>Speed</label>
          <input type="range" min="0.1" max="3" step="0.1" defaultValue="1" />
        </div>
      </div>
      
      <div className="tour-actions">
        <button className="action-btn primary">
          <i className="fas fa-play"></i>
          <span>Start Tour</span>
        </button>
      </div>
    </div>
  );
};

export default VirtualTour;
